import axios from 'axios';
import authHeader from 'src/mtska-frontend-data-provider/redux/authHeader';
import { handleError, handleSuccess } from 'src/mtska-frontend-data-provider/redux/handleResponse';

const endpointBase = process.env.REACT_APP_API_ENDPOINT || window.location.origin + '/api';
const pollEndpoint = `${endpointBase}/poll`;

export const pollOnce = async () => {
    const axiosRequestOptions = {
        url: pollEndpoint,
        method: 'GET',
        headers: authHeader(),
    };

    return axios(axiosRequestOptions).then(handleSuccess).catch(handleError);
};

